module.exports = __webpack_public_path__ + "img/default_feng_mian.c81c838b.jpg";